import type { FC } from "react";
import React from "react";

import { Radio } from "@mui/material";

import clsx from "clsx";

import { StyledRadioBtn } from "./style";

interface RadionBtnProps {
	label: string;
	value: string | boolean;
	rtl?: boolean;
	className?: string;
	id?: string;
	disabled?: boolean;
}

const RadionBtn: FC<RadionBtnProps> = ({ label, value, rtl = false, id, className = "", disabled }) => (
	<StyledRadioBtn
		id={id}
		value={value}
		control={<Radio />}
		label={label}
		disabled={disabled}
		className={clsx(className, rtl && "rtl")}
	/>
);

export default RadionBtn;
